import { createStyles } from '@mantine/emotion';

export const useStyles = createStyles(() => ({
  ldapLabel: {
    marginTop: '0!important' as any
  }
}));
